/* eslint-disable */
// src/layouts/visitMachine/strategies/RentStrategy.js

/* File: src/layouts/visitMachine/strategies/<tipo>Strategy.js
 * Estrategia concreta (Tragamoneda/Pool-Tejo/Rockola/Peluchera).
 * Implementa calculate(...) para producir moneyIn/Out, netos y collected.
 * No toca la UI; sólo devuelve números/flags que luego muestra el builder.
 */

export class RentStrategy {
  calculate(machine, userInputs, visitMachineDetails, profitPercentages, isEditMode, prevRecords) {
    const keyId = Number(machine?.LocalMachineId ?? machine?.Id);

    const original = isEditMode
      ? prevRecords.find((r) => Number(r.LocalMachineId) === keyId)
      : null;

    const rentPriceRaw = machine.Rent?.Price ?? machine.RentPrice ?? null;
    const parsedRentPrice = rentPriceRaw == null ? null : Number(rentPriceRaw);
    const rentPrice = Number.isFinite(parsedRentPrice) ? parsedRentPrice : null;
    const rentId = (machine.Rent?.Id ?? machine.RentId ?? machine.LocalMachineRentId ?? null);

    return {
      LastVisitMachineId: original?.LastVisitMachineId,
      LocalMachineId: original?.LocalMachineId || keyId,
      VisitWithCollectionId: null,
      note: userInputs[keyId]?.Note || "",
      CreditsIn: null,
      CreditsOut: null,
      creditsCollected: null,
      moneyCollected: rentPrice,
      clientAmount: 0,
      ownerAmount : rentPrice,
      NetCreditsIn: null,
      NetCreditsOut: null,
      moneyIn: null,
      moneyOut: null,
      LocalMachineProfitPercentageId: null,
      MachineType: machine.MachineType ?? null,
      Machine: machine.Machine ?? null,
      Formula: null,
      MachineTypeId: machine.MachineType?.Id ?? null,
      FormulaId: null,
      Rent: machine.Rent ?? (rentId ? { Id: rentId, Price: rentPrice, PaymentFrequency: machine.Rent?.PaymentFrequency ?? machine.RentPaymentFrequency ?? null } : null),
      RentId: rentId,
    };
  }
}
